import { API_URL } from '@/api';
import { ExportHistoryBody, ExportType } from '@/pages/History/typings';
import axios from 'axios';
import { TIMEOUT_EXPORT_HISTORY } from './config';

export type HistoryParamsBody = {
  deviceIds: string[];
  parameterIds: string[];
};

export const getHistoryParameters = (servicePartnerId: string | number, params: { deviceIds: string }) =>
  axios.get(`${API_URL}/v2/service-partners/${servicePartnerId}/history/parameters`, {
    params,
  });

export const getHistoryObjects = (servicePartnerId: string | number) =>
  axios.get(`${API_URL}/v2/service-partners/${servicePartnerId}/me/history`);

export const createHistoryObject = (servicePartnerId: string | number, body: HistoryParamsBody) =>
  axios.post(`${API_URL}/v2/service-partners/${servicePartnerId}/me/history`, body);

export const deleteHistoryObject = (servicePartnerId: string | number, historyId: string) =>
  axios.delete(`${API_URL}/v2/service-partners/${servicePartnerId}/history/${historyId}`);

export const editHistoryObject = (servicePartnerId: string | number, historyId: string, body: any) =>
  axios.put(`${API_URL}/v2/service-partners/${servicePartnerId}/history/${historyId}`, body);

export const getHistoryPoints = (
  servicePartnerId: string | number,
  deviceId: string,
  parameterId: string,
  dateFrom: any,
  dateTo: any,
  aggregationMethod = 'average',
  aggregationUnit = 'none',
  isEnumParameter = false,
) =>
  axios.get(
    `${API_URL}/v2/service-partners/${servicePartnerId}/history/${deviceId}/points/${parameterId}/${dateFrom}/${dateTo}/${aggregationMethod}/${aggregationUnit}`,
    isEnumParameter ? { params: { includeOuterBounds: true } } : undefined,
  );

export const exportHistory = ({
  deviceId,
  exportType = ExportType.Default,
  parameterIds,
  dateFrom,
  dateTo,
}: ExportHistoryBody) =>
  axios.post(
    `${API_URL}/v2/devices/${deviceId}/history/export`,
    { exportType, parameterIds, dateFrom, dateTo },
    { responseType: 'blob', timeout: TIMEOUT_EXPORT_HISTORY },
  );
